// src/context/CartContext.js
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem("ps_cart");
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      console.error("Erreur lecture panier localStorage", e);
      return [];
    }
  });

  // Sauvegarde dans localStorage
  useEffect(() => {
    try {
      localStorage.setItem("ps_cart", JSON.stringify(items));
    } catch (e) {
      console.error("Erreur sauvegarde panier", e);
    }
  }, [items]);

  const addItem = (product, quantity = 1) => {
    if (!product || !product.id) return;

    const qty = quantity > 0 ? quantity : 1;
    const price = Number(product.price) || 0;

    setItems((prev) => {
      const existing = prev.find((it) => it.id === product.id);
      if (existing) {
        return prev.map((it) =>
          it.id === product.id
            ? { ...it, quantity: it.quantity + qty }
            : it
        );
      }
      return [
        ...prev,
        {
          id: product.id,
          slug: product.slug,
          name: product.name,
          price,
          mainImage: product.mainImage || product.image || "",
          quantity: qty,
        },
      ];
    });
  };

  const updateQty = (id, quantity) => {
    setItems((prev) =>
      prev.map((it) =>
        it.id === id
          ? { ...it, quantity: quantity <= 0 ? 1 : quantity }
          : it
      )
    );
  };

  const removeItem = (id) => {
    setItems((prev) => prev.filter((it) => it.id !== id));
  };

  const clearCart = () => setItems([]);

  const totalItems = useMemo(
    () => items.reduce((sum, it) => sum + it.quantity, 0),
    [items]
  );

  const totalAmount = useMemo(
    () => items.reduce((sum, it) => sum + it.quantity * it.price, 0),
    [items]
  );

  const value = {
    items,
    addItem,
    updateQty,
    removeItem,
    clearCart,
    totalItems,
    totalAmount,
  };

  return (
    <CartContext.Provider value={value}>{children}</CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) {
    throw new Error("useCart doit être utilisé dans un CartProvider");
  }
  return ctx;
}
